

export const GROUP_LIST_REQUEST = "GROUP_LIST_REQUEST";
export const GROUP_LIST_SUCCESS = "GROUP_LIST_SUCCESS";
export const GROUP_LIST_FAIL = "GROUP_LIST_FAIL";
export const GROUP_LIST_RESET = "GROUP_LIST_RESET";
